// manual importing of products 

import product1 from "./assets/1.webp"; 
import product2 from "./assets/2.webp"; 
import product3 from "./assets/3.webp"; 
import product4 from "./assets/4.webp"; 
import product5 from "./assets/5.webp"; 
import product6 from "./assets/6.webp"; 
import product7 from "./assets/7.jpg"; 
import product8 from "./assets/8.jpg"; 
import product9 from "./assets/11.webp"; 
import product10 from "./assets/14.webp";
import product11 from "./assets/13.webp";   
import product12 from "./assets/15.webp"; 
import product13 from "./assets/hat.webp"; 
import product14 from "./assets/16.webp"; 
import product15 from "./assets/17.webp"; 

export const PRODUCTS = [
  {
    id: 1,
    productName: "IPhone",
    price: 1000.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Macbook Pro 2022 (M1)",
    price: 30000.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Cannon Camera",
    price: 2999.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Podcasting Mic",
    price: 500.0,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Denim Jacket",
    price: 1999.99,
    productImage: product5,
  },
  {
    id: 6,
    productName: "LED Light Strip",
    price: 1290.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Tee Shirt",
    price: 200.0,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Tee Fancy",
    price: 239.0,
    productImage: product8,
  },
  {
    id: 9,
    productName: "Rotating Chair",
    price: 4200.0,
    productImage: product9,
  },
  {
    id: 10,
    productName: "Rgb Mouse",
    price: 230.0,
    productImage: product10,
  },
  {
    id: 11,
    productName: "Monitor",
    price: 90.0,
    productImage: product11,
  },
  {
    id: 12,
    productName: "keyboard rgb",
    price: 400.0,
    productImage: product12,
  },
  {
    id: 13,
    productName: "fancy top tee",
    price: 450.0,
    productImage: product13,
  },
  {
    id: 14,
    productName: "wireless mic",
    price: 40.0,
    productImage: product14,
  },
  {
    id: 15,
    productName: "GO PRO CAM",
    price: 100.0,
    productImage: product15,
  },


];